import { render } from "./App.vue?vue&type=template&id=5124cad7&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5124cad7&scoped=true&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_nnqy633ba33w3ap4lrqhdb3em4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5124cad7"]])

export default __exports__